const STORAGE_KEY = 'colorphoto_lang'

export const LANGS = ['he', 'en']

export function getInitialLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'he' || v === 'en') return v
  } catch {}
  return 'he'
}

export function saveLang(lang) {
  try { localStorage.setItem(STORAGE_KEY, lang) } catch {}
}

export const STRINGS = {
  he: {
    langLabel: 'עברית',
    langToggle: 'EN',
    speakMode: 'הקראה',
    accessibility: 'נגישות',
    menu: 'תפריט',
    templates: 'תבניות לצביעה',
    geoShapes: 'צורות גאומטריות',
    gallery: 'גלריה',
    blankPage: 'דף ריק',
    share: 'שתף',
    shareQr: 'שתף - הצג קוד QR',
  },
  en: {
    langLabel: 'English',
    langToggle: 'עברית',
    speakMode: 'Read aloud',
    accessibility: 'Accessibility',
    menu: 'Menu',
    templates: 'Templates',
    geoShapes: 'Geometric shapes',
    gallery: 'Gallery',
    blankPage: 'Blank page',
    share: 'Share',
    shareQr: 'Share - show QR code',
  },
}

export function t(lang, key) {
  return STRINGS[lang]?.[key] ?? STRINGS.he[key] ?? key
}

